import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowUpRight, Clock } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTABand } from "@/components/CTABand";
import { Seo, localBusinessSchema, breadcrumbSchema } from "@/seo/Seo";
import { POSTS } from "@/data/blogData";

export default function BlogIndex() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const crumbs = [{ name: "Home", path: "/" }, { name: "Tips & Advice", path: "/tips" }];

  return (
    <div className="bg-white min-h-screen" data-testid="blog-index">
      <Seo
        title="Handyman Tips & Advice | Swansea DIY & Repairs | FIT N FIX"
        description="Practical handyman, DIY, masonry and property maintenance tips for Swansea homes and landlords — from spotting a failed lintel to gutter cleaning and flat-pack advice."
        path="/tips"
        keywords={["handyman tips swansea", "diy advice swansea", "home maintenance tips", "property maintenance advice"]}
        jsonLd={[localBusinessSchema(), breadcrumbSchema(crumbs)]}
      />
      <Navbar />

      <section className="pt-[110px] sm:pt-[130px] pb-12 blueprint">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <Breadcrumbs items={crumbs} />
          <h1 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.92] mt-5 max-w-4xl">
            TIPS &amp; ADVICE<br /><span className="text-[#2563EB]">FROM THE TOOLBOX</span>
          </h1>
          <p className="text-lg text-[#0A1A4A]/70 mt-6 max-w-2xl">
            Straight-talking guides on home repairs, DIY, masonry and property maintenance — from your local Swansea handyman.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/tips/${p.slug}`} className="group border-2 border-[#0A1A4A] overflow-hidden hover:shadow-hard transition-shadow bg-white flex flex-col" data-testid={`post-card-${p.slug}`}>
              <div className="h-44 overflow-hidden border-b-2 border-[#0A1A4A] relative">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 bg-[#2563EB] text-white font-mono-accent text-[10px] tracking-widest uppercase px-2 py-1 border border-[#0A1A4A]">{p.category}</span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 font-mono-accent text-[10px] tracking-widest uppercase text-[#0A1A4A]/50 mb-3">
                  <Clock size={12} /> {p.read} read
                </div>
                <h2 className="font-display font-extrabold uppercase text-lg text-[#0A1A4A] leading-tight">{p.title}</h2>
                <p className="text-sm text-[#0A1A4A]/70 mt-2 flex-1">{p.excerpt}</p>
                <div className="mt-4 flex items-center gap-1 font-mono-accent text-[11px] tracking-widest uppercase text-[#2563EB]">
                  Read more <ArrowUpRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <CTABand />
      <Footer />
    </div>
  );
}
